import { useMemo } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { useVolumeHover } from "~/feature/chart/providers/VolumeHoverProvider";
import { ChartViewEnum } from "~/feature/chart/types";

import { buildConsensusLegend, buildMarketItems } from "./buildLegend";

export const useMarketsLegend = () => {
  const {
    markets,
    selections,
    chanceHistory,
    isChanceHistoryFetching,
    isChanceHistoryUnavailable,
    viewMode,
    range,
  } = useCoreChart();
  const { hoveredIndex } = useVolumeHover();

  const legend = useMemo(() => {
    if (isChanceHistoryUnavailable) {
      return { rangeLabel: range, items: [], consensus: null };
    }

    const isConsensus = viewMode === ChartViewEnum.CONSENSUS;

    return {
      rangeLabel: range,
      items: isConsensus
        ? []
        : buildMarketItems(
            markets,
            selections,
            chanceHistory,
            viewMode,
            isChanceHistoryFetching
          ),
      consensus: isConsensus
        ? buildConsensusLegend(
            markets,
            selections,
            chanceHistory,
            isChanceHistoryFetching
          )
        : null,
    };
  }, [
    markets,
    chanceHistory,
    isChanceHistoryFetching,
    isChanceHistoryUnavailable,
    range,
    selections,
    viewMode,
  ]);

  return { ...legend, isDimmed: hoveredIndex !== null };
};
